import React from 'react';

const BLOG_POSTS = [
  {
    id: 'understanding-mahadasha',
    title: 'Understanding Mahadashas: Your Life in Cycles',
    excerpt: 'The 120-year Vimshottari cycle reveals the planetary periods shaping your life. Learn how to interpret your current dasha.',
    category: 'Vedic Basics',
    readTime: '8 min',
    image: '🪔',
    date: 'May 1, 2026'
  },
  {
    id: 'sade-sati-explained',
    title: 'Sade Sati: Saturn\'s 7.5-Year Test',
    excerpt: 'Why does Saturn\'s transit through Capricorn-Aquarius-Pisces (or your Moon\'s neighbors) feel like a karmic challenge? Decoding the phases.',
    category: 'Predictions',
    readTime: '12 min',
    image: '⚖️',
    date: 'Apr 28, 2026'
  },
  {
    id: 'manglik-myth-or-reality',
    title: 'Manglik Dosha: Myth or Reality?',
    excerpt: 'Mars in 1, 2, 4, 7, 8, 12 from Lagna — but does it really doom your marriage? Modern interpretation.',
    category: 'Compatibility',
    readTime: '10 min',
    image: '♂️',
    date: 'Apr 25, 2026'
  },
  {
    id: 'kp-vs-parasara',
    title: 'KP System vs Parasara: Which is More Accurate?',
    excerpt: 'Krishnamurti Paddhati uses sub-divisions for predictions. How does it compare to traditional Parasara?',
    category: 'Methodology',
    readTime: '15 min',
    image: '🌟',
    date: 'Apr 22, 2026'
  },
  {
    id: 'navamsa-deep-dive',
    title: 'Navamsa (D9): The Chart of Your Soul',
    excerpt: 'The most important divisional chart. What it reveals about your marriage, dharma, and inner strength.',
    category: 'Divisional Charts',
    readTime: '14 min',
    image: '✨',
    date: 'Apr 18, 2026'
  },
  {
    id: 'gajakesari-yoga',
    title: 'Gajakesari Yoga: The Power of Jupiter and Moon',
    excerpt: 'When Jupiter is in a kendra from the Moon, it creates one of the most beneficial yogas. Learn its effects.',
    category: 'Yogas',
    readTime: '6 min',
    image: '🐘',
    date: 'Apr 15, 2026'
  }
];

function BlogPage({ onBack }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-950 to-slate-900 text-white">
      {/* Header */}
      <div className="border-b border-slate-800 px-6 py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <button onClick={onBack} className="text-white/70 hover:text-white">← Back to Home</button>
          <h1 className="text-xl font-bold">📚 Blog</h1>
          <div className="w-20"></div>
        </div>
      </div>

      {/* Hero */}
      <section className="px-6 py-16 text-center max-w-4xl mx-auto">
        <h1 className="text-5xl font-bold mb-4">Vedic Astrology Insights</h1>
        <p className="text-xl text-white/70">Deep dives into classical texts, modern interpretations, and AI-grounded analysis</p>
      </section>

      {/* Filter tags */}
      <section className="px-6 max-w-6xl mx-auto mb-8">
        <div className="flex flex-wrap gap-2">
          {['All', 'Vedic Basics', 'Predictions', 'Compatibility', 'Methodology', 'Divisional Charts', 'Yogas', 'Doshas'].map(tag => (
            <button key={tag} className="px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-full text-sm">
              {tag}
            </button>
          ))}
        </div>
      </section>

      {/* Blog grid */}
      <section className="px-6 max-w-6xl mx-auto pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map(post => (
            <article key={post.id}
              className="bg-slate-800/50 backdrop-blur border border-slate-700 rounded-xl overflow-hidden hover:bg-slate-800/80 transition cursor-pointer group">
              <div className="h-48 bg-gradient-to-br from-purple-500/30 to-pink-500/20 flex items-center justify-center text-7xl">
                {post.image}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3 text-xs">
                  <span className="px-3 py-1 bg-purple-500/20 border border-purple-400/30 rounded-full text-purple-300">
                    {post.category}
                  </span>
                  <span className="text-white/50">{post.readTime}</span>
                </div>
                <h2 className="text-xl font-bold mb-3 group-hover:text-purple-300 transition">{post.title}</h2>
                <p className="text-white/70 text-sm mb-4 leading-relaxed">{post.excerpt}</p>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-white/50">{post.date}</span>
                  <span className="text-purple-400 font-semibold">Read →</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-white/60 mb-4">Want more? Subscribe for new articles weekly.</p>
          <div className="flex justify-center gap-2 max-w-md mx-auto">
            <input type="email" placeholder="your@email.com"
              className="flex-1 px-4 py-3 bg-slate-800 border border-slate-700 rounded-lg focus:outline-none focus:border-purple-400" />
            <button className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-lg font-bold transition">
              Subscribe
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogPage;
